module.exports = __webpack_public_path__ + "img/function-go.da8c3149.png";